DialogController = App.loadClass 'core::Angular/DialogController'

class exports.DialogController extends DialogController

    constructor: (@scope, @transitions, @modalInstance, @state) ->
        super(@scope, @transitions, @modalInstance)

        # init scope stuff that's global to the whole dialog
        @scope.step =
            title: ''
            buttonText: 'Next'
            loading: false
            previous: () -> return
            next: () -> return
            includeDuplicates: () -> return
            canContinue: () -> return

        @scope.selected =
            years: []
            spps: []
            survey_results: []
            duplicate_fields: []
            downloading: false

        @scope.title = ''
        # update the dialog title whenever the step title changes
        @scope.$watch 'step.title', (title) =>
            @scope.title = title

        @scope.currentStepIs = @currentStepIs
        @scope.previous = @previous
        @scope.next = @next
        @scope.includeDuplicates = @includeDuplicates
        @scope.canContinue = @canContinue
        @scope.goToStep = @goToStep

        @goToStep('select_year_and_crop')


    currentStepIs: (params...) =>
        for step_name in params
            if @state.includes("grower.placement.report.#{step_name}")
                return true
        return false

    previous: () =>
        # pass control of navigation to the current step
        @scope.step.previous()

    canContinue: () =>
        if @scope.selected.downloading
            return false

        # pass control of navigation to the current step
        return @scope.step.canContinue()

    next: () =>
        # pass control of navigation to the current step
        @scope.step.next()

    includeDuplicates: () =>
        # this behavior is also dependent on step
        @scope.step.includeDuplicates()

    goToStep: (step_name) =>
        # this normally shouldn't do anything. it should only be set for the
        # duplicate_fields and farm_field steps.
        @scope.step.includeDuplicates = () ->
            undefined

        @state.go("grower.placement.report.#{step_name}", null, location: false)
